import { Box, Text, VStack } from "@chakra-ui/react";

const PageHeader = ({
  title,
  subtitle,
  emoji,
}: {
  title: string;
  subtitle: string;
  emoji?: string;
}) => (
  <VStack align="flex-start" spacing={1}>
    <Text fontSize="xl" fontWeight="500" fontFamily="HubotSans, sans-serif" color="text.body.primary">
      {emoji && <Box as="span" mr={2}>{emoji}</Box>}
      {title}
    </Text>
    <Text fontSize="sm" color="text.body.tertiary">
      {subtitle}
    </Text>
  </VStack>
);

export default PageHeader;
